module.exports = __webpack_public_path__ + "static/img/index-icon-carDdc.af88bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/street/index-icon-carDdc.png
// module id = /205
// module chunks = 208